import React from "react"
export const EmptyList = () => (
    <div className="my-device-title">Pick up a device?</div>
)
